import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, change, reduxForm } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { isRequired } from '../../../../../utils/validators';
import FormItem from '../../../../common/forms/FormItem';
import FormFooter from '../../../../common/forms/FormFooter';
import RegisteredBusSelect from '../../../../common/forms/select/RegisteredBusSelect';
import TextInput from '../../../../common/forms/input/TextInput';
import TripCircuitStatusSelect from '../../../../common/forms/select/TripCircuitStatusSelect';
import { getTotalPassengerSeats } from '../itinerary-for-counter/ItineraryForCounterForm';
import { generateDifferentBusCapacityWarningMessage } from '../../../../../config/messages';
import { getBusMaintenanceStayConflicts } from '../../../../../actions';
import Loader from '../../../../common/Loader';

const ItinerariesForSchedulingForm = ({
  handleSubmit,
  passengerSeatCapacity,
  initialValues,
  dispatchGetBusMaintenanceStayConflicts
}) => {
  const [selectedSeatMap, setSelectedSeatMap] = useState(null);
  const [companyBusId, setCompanyBusId] = useState(null);
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [isLoadingMaintenance, setIsLoadingMaintenance] = useState(false);

  let registeredBusRef;
  let tripCircuitStatusRef;

  const { id: itineraryId } = initialValues || {};

  useEffect(() => {
    registeredBusRef.focus();
  }, []);

  const onChangeRegisteredBus = async (bus) => {
    if (tripCircuitStatusRef && tripCircuitStatusRef.focus)
      tripCircuitStatusRef.focus();

    if (bus.value) {
      setSelectedSeatMap(bus.seatMap);
      setCompanyBusId(bus.companyBusId);
      setIsLoadingMaintenance(true);
      const response = await dispatchGetBusMaintenanceStayConflicts({ itineraryId, busId: bus.value })
      setIsLoadingMaintenance(false);
      const hasConflicts = response && response.length > 0;
      if (hasConflicts) {
        setIsUnderMaintenance(true);
        toastr.warning(
          'Conflicto de Mantenimiento',
          'El bus seleccionado tiene estadías de mantenimiento programadas que entran en conflicto con el itinerario.'
        );
      } else {
        setIsUnderMaintenance(false);
      }
    }
  };

  let warningComponent = null;
  if (selectedSeatMap && passengerSeatCapacity > 0) {
    const newTotalPassengerSeats = getTotalPassengerSeats(selectedSeatMap);
    if (newTotalPassengerSeats < passengerSeatCapacity) {
      warningComponent = (
        <span className="text-warning">
          <i className="fa fa-warning" /> <strong>Advertencia:</strong>{' '}
          {generateDifferentBusCapacityWarningMessage({
            newCompanyBusId: companyBusId,
            newTotalPassengerSeats,
            currentTotalPassengerSeats: passengerSeatCapacity,
          })}
          .
        </span>
      );
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Bus" required>
          <Field
            name="companyBusId"
            component={RegisteredBusSelect}
            onChange={onChangeRegisteredBus}
            validate={[isRequired]}
            isClearable={false}
            setFieldToBeFocused={(input) => {
              registeredBusRef = input;
            }}
            onlyActive
          />
          {warningComponent}
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Orden en Circuito" required>
          <Field
            name="tripCircuitStatus"
            component={TripCircuitStatusSelect}
            validate={[isRequired]}
            isClearable={false}
            setFieldToBeFocused={(input) => {
              tripCircuitStatusRef = input;
            }}
          />
        </FormItem>
      </FormGroup>
      {
        isLoadingMaintenance && (
          <Loader />
        )
      }
      {
        isUnderMaintenance && (
          <FormGroup row>
            <FormItem label="Motivo de Programación" required>
              <Field
                name="maintenanceReason"
                component={TextInput}
                type="textarea"
                validate={[isRequired]}
              />
            </FormItem>
          </FormGroup>
        )
      }

      <Field name="id" component={TextInput} type="hidden" />
      <FormFooter
        saveButtonDisabled={isLoadingMaintenance}
      />
    </Form>
  );
};

ItinerariesForSchedulingForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  passengerSeatCapacity: PropTypes.number.isRequired,
  initialValues: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  dispatchGetBusMaintenanceStayConflicts: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchChange: change,
  dispatchGetBusMaintenanceStayConflicts: getBusMaintenanceStayConflicts
};

const formComponent = reduxForm({
  form: 'ItinerariesForSchedulingForm',
})(ItinerariesForSchedulingForm);

export default connect(null, mapDispatchToProps)(formComponent);
